import React from 'react'

import SecretWindowContainer from './components/SecretWindowContainer'
import {
  H1,
} from '../styles'

const ActivePrompt = ({game, players, player}) => {
  if (player && !player.alive) {
    return <div>
      <H1>You're dead</H1>
      <p>Your poison word was "{player.poisonWord}"</p>
      <p>But the game is still going! You can still help the assassins who are still alive (if you want to)</p>
    </div>
  } else {
    return <div>
      <H1>Game on!</H1>
      { player ? <SecretWindowContainer players={players} /> : null }
    </div>
  }
}

export default ActivePrompt



// WEBPACK FOOTER //
// ./src/views/game/2_ActivePrompt.jsx